module.exports = __webpack_public_path__ + "e62f1ed0f96c97d7a6e2026efcfb03e4.png";